import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgCalendar = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M7.77 2.75a.75.75 0 1 0-1.5 0v5.692a.75.75 0 0 0 1.5 0V6.346h6.365a.75.75 0 0 0 0-1.5H7.769zM2.635 5.483c.408-.408.96-.637 1.537-.637a.75.75 0 1 1 0 1.5.673.673 0 0 0-.673.673v3.52h17v-3.52a.673.673 0 0 0-.673-.673H17.73v2.096a.75.75 0 0 1-1.5 0V2.75a.75.75 0 1 1 1.5 0v2.096h2.096A2.173 2.173 0 0 1 22 7.02v12.808A2.173 2.173 0 0 1 19.827 22H4.173A2.173 2.173 0 0 1 2 19.827V7.019c0-.576.229-1.129.636-1.536M3.5 19.827v-7.789h17v7.789a.673.673 0 0 1-.673.673H4.173a.673.673 0 0 1-.673-.673"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgCalendar;
